import { ThunkType } from "../../../../../core/store/reducers";
import { setData } from "../commReviewDataSlice";
import getCommReviewDataApi from "../api/getCommReviewData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.exchbusiness.commReview;

  const pagedTrades = await dispatch(getCommReviewDataApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
